import { Components, Theme } from '@mui/material';

import { MuiAlert } from './MuiAlert';
import { MuiCheckbox } from './MuiCheckbox';
import { MuiContainer } from './MuiContainer';
import { MuiFormControl } from './MuiFormControl';
import { MuiInputLabel } from './MuiInputLabel';
import { MuiMenu } from './MuiMenu';
import { MuiMenuItem } from './MuiMenuItem';
import { MuiPickersDay } from './MuiPickersDay';
import { MuiPickersInputBase } from './MuiPickersInputBase';
import { MuiPopover } from './MuiPopover';
import { MuiRadio } from './MuiRadio';
import { MuiSelect } from './MuiSelect';
import { MuiTextField } from './MuiTextField';
import { MuiTooltip } from './MuiTooltip';

export const componentOverrides: Components<Theme> = {
  MuiAlert,
  MuiContainer,
  MuiFormControl,
  MuiInputLabel,
  MuiMenu,
  MuiMenuItem,
  MuiPickersDay,
  MuiPickersInputBase,
  MuiPopover,
  MuiSelect,
  MuiTextField,
  MuiRadio,
  MuiCheckbox,
  MuiTooltip,
};
